// Import-stage entry that resolves `.luis` imports before normalization.
// It keeps `.css` imports untouched and emits ordering diagnostics.
import type { LuisCompileOptions, LuisCompileWarning } from '../types'
import type { LuisSourceLineOrigin } from './line-map-types'
import { resolveLuisImportsInternal } from './resolve'

// Resolve compile-time imports and return source with warnings.
export function resolveLuisImports(
  source: string,
  options: LuisCompileOptions,
): { source: string; warnings: LuisCompileWarning[]; lineMap: LuisSourceLineOrigin[] } {
  // Return resolved source and warnings from internal resolver.
  return resolveLuisImportsInternal(source, options)
}
